module.exports = __webpack_public_path__ + "img/Stapler_3t.2e4b5eb9.svg";